/******/ (function() { // webpackBootstrap
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
/**
 * Section: Help center drop down
 * ------------------------------------------------------------------------------
 *
 * @namespace HelpCenterDropDown
 */
var HelpCenterDropDown = /*#__PURE__*/function (_HTMLElement) {
  function HelpCenterDropDown() {
    var _this;
    _classCallCheck(this, HelpCenterDropDown);
    _this = _callSuper(this, HelpCenterDropDown);

    // Bind methods to preserve context
    _this.handleClick = _this.handleClick.bind(_this);
    _this.init();
    return _this;
  }
  _inherits(HelpCenterDropDown, _HTMLElement);
  return _createClass(HelpCenterDropDown, [{
    key: "init",
    value: function init() {
      this.setupElements();
      this.setupEventListeners();
      this.setInitialState();
    }
  }, {
    key: "setupElements",
    value: function setupElements() {
      this.trigger = this.querySelector('.help-center-drop-down__trigger');
      this.dropDown = this.querySelector('.help-center-drop-down__accordion');
      this.svg = this.querySelector('svg');
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      if (this.trigger) {
        this.trigger.addEventListener('click', this.handleClick);
      }
    }
  }, {
    key: "setInitialState",
    value: function setInitialState() {
      // Set initial state to closed
      this.setAttribute('open', 'false');
      this.updateAriaExpanded('false');
      this.updateVisualState(false);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var isCurrentlyOpen = this.getAttribute('open') === 'true';
      if (isCurrentlyOpen) {
        // Close this dropdown
        this.close();
      } else {
        // Close all other dropdowns first, then open this one
        this.closeAllOtherDropdowns();
        this.open();
      }
    }
  }, {
    key: "open",
    value: function open() {
      this.setAttribute('open', 'true');
      this.updateAriaExpanded('true');
      this.updateVisualState(true);
    }
  }, {
    key: "close",
    value: function close() {
      this.setAttribute('open', 'false');
      this.updateAriaExpanded('false');
      this.updateVisualState(false);
    }
  }, {
    key: "updateAriaExpanded",
    value: function updateAriaExpanded(value) {
      if (this.trigger) {
        this.trigger.setAttribute('aria-expanded', value);
      }
    }
  }, {
    key: "updateVisualState",
    value: function updateVisualState(isOpen) {
      if (this.dropDown) {
        if (isOpen) {
          this.dropDown.classList.remove('hidden');
        } else {
          this.dropDown.classList.add('hidden');
        }
      }
      if (this.svg) {
        if (isOpen) {
          this.svg.classList.add('rotate-180');
        } else {
          this.svg.classList.remove('rotate-180');
        }
      }
    }
  }, {
    key: "closeAllOtherDropdowns",
    value: function closeAllOtherDropdowns() {
      var _this2 = this;
      var allDropdowns = document.querySelectorAll('help-center-drop-down');
      allDropdowns.forEach(function (dropdown) {
        if (dropdown !== _this2) {
          dropdown.close();
        }
      });
    }

    // Handle attribute changes
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'open' && oldValue !== newValue) {
        var isOpen = newValue === 'true';
        this.updateAriaExpanded(newValue);
        this.updateVisualState(isOpen);
      }
    }

    // Cleanup when element is removed
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.trigger) {
        this.trigger.removeEventListener('click', this.handleClick);
      }
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['open'];
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('help-center-drop-down', HelpCenterDropDown);
/******/ })()
;